import { useHistory } from 'react-router-dom'

const Archive = () => {
    useHistory().goBack()
    return null
}

export default Archive
